const RequiredField = () => {
  return (
    <>
      <span className="text-red-600">*</span>
    </>
  );
};

export default RequiredField;
